import {
  canDetectTarget,
  getDistanceBetweenPoints,
} from '../rangerLogic';
import {
  ENEMY_ALERT_DURATION_MS,
  ENEMY_ALERT_SPREAD_RANGE,
  ENEMY_INVESTIGATE_MS,
} from '../rangerTuning';

export function getVisionBlockers(level) {
  return [
    ...(level.obstacles ?? []),
    ...(level.terrains ?? []).filter((terrain) => terrain.type === 'trench'),
  ];
}

export function enemyCanSeePlayer(scene, enemy) {
  const data = enemy.enemyData;
  const viewer = { x: enemy.x, y: enemy.y };
  const target = { x: scene.player.x, y: scene.player.y };

  return canDetectTarget({
    viewer,
    target,
    facingDirection: data.facingDirection,
    range: data.visionRange ?? 150,
    angleDegrees: data.visionAngle ?? 58,
    rangeMultiplier: scene.playerClassConfig?.detectionMultiplier ?? 1,
    blockers: scene.visionBlockers,
  });
}

export function setEnemyAwareness(enemy, state, scene, lastKnownPlayer) {
  const data = enemy.enemyData;

  data.awarenessState = state;
  data.lastKnownPlayer = lastKnownPlayer ?? data.lastKnownPlayer;

  if (state === 'investigating') {
    data.investigateUntil = scene.time.now + (data.investigationMs ?? ENEMY_INVESTIGATE_MS);
    data.alertedUntil = Math.max(data.alertedUntil ?? 0, scene.time.now + ENEMY_ALERT_DURATION_MS);
  }

  if (state === 'attacking') {
    data.alertedUntil = Math.max(data.alertedUntil ?? 0, scene.time.now + ENEMY_ALERT_DURATION_MS);
    data.nextShotTime = Math.min(data.nextShotTime ?? 0, scene.time.now + 220);
  }
}

export function spreadEnemyAlert(scene, sourceEnemy) {
  const lastKnownPlayer = {
    x: scene.player.x,
    y: scene.player.y,
  };

  scene.enemies?.forEach((enemy) => {
    if (enemy === sourceEnemy || enemy.enemyData.defeated) {
      return;
    }

    if (getDistanceBetweenPoints(sourceEnemy, enemy) > ENEMY_ALERT_SPREAD_RANGE) {
      return;
    }

    if (enemy.enemyData.awarenessState === 'attacking') {
      return;
    }

    setEnemyAwareness(enemy, 'investigating', scene, lastKnownPlayer);
  });
}